<template>
  <div class="content-block dx-card responsive-paddings">
    <DxForm :ref="formTLLRefName" label-location="left" :formData="formTLLData">
      <DxSimpleItem data-field="userId" editor-type="dxSelectBox"
        :editor-options="{ width: 300, items: userList, searchEnabled: true, displayExpr: 'userNameId', valueExpr: 'id', onValueChanged: onValueChangedUser }">
        <DxLabel text="사용자" />
      </DxSimpleItem>
    </DxForm>
  </div>
  <div class="content-block dx-card responsive-paddings">
    <DxDataGrid id="gridContainer" :ref="gridRefName" :data-source="spaceList" :columnAutoWidth="true"
      :show-borders="true" :show-column-lines="true" @exporting="onExporting" :selection="{ mode: 'multiple' }"
      @toolbar-preparing="onToolbarPreparing($event)">
      <DxScrolling mode="virtual" />
      <DxColumn data-field="spaceName" caption="스페이스 이름" />
      <DxColumn data-field="spaceId" caption="스페이스 ID" />
    </DxDataGrid>
  </div>
</template>

<script>
import {
  DxDataGrid,
  DxColumn,
  DxScrolling
} from "devextreme-vue/data-grid";
import DxForm, {
  DxLabel,
  DxSimpleItem
} from "devextreme-vue/form";
import dsu from "../../utils/dataSourceUtils";
import fn from "../../utils/function";

export default {
  components: {
    DxDataGrid,
    DxColumn,
    DxScrolling,
    DxForm,
    DxLabel,
    DxSimpleItem
  },
  data() {
    return {
      userList: [],
      selectedUserId: '',
      gridRefName: 'grid'
    };
  },
  mounted() {
    var params = {};
    params.exceptAdmin = 'Y';
    dsu.getAxiosOBJGet('/api/AUSR/select', params).then(res => {
      if (res.data.result == 'SUCCESS') {
        this.userList = res.data.data;
      }
    });
  },
  computed: {
    grid: function () {
      return this.$refs[this.gridRefName].instance;
    }
  },
  methods: {
    setGridData(data) {
      this.grid.option('dataSource', data);
      this.grid.option('keyExpr', 'spaceId');
      this.grid.deselectAll();
      var selectedItems = [];
      for (var i = 0; i < data.length; i++) {
        if (data[i].auth == 'Y') {
          selectedItems.push(data[i].spaceId);
        }
      }
      this.grid.selectRows(selectedItems, true);
    },
    onValueChangedUser(e) {
      var params = {};
      this.selectedUserId = e.value;
      params.targetUserId = e.value;
      dsu.getAxiosOBJGet('/api/AATH/select', params).then(res => {
        if (res.data.result == 'SUCCESS') {
          this.setGridData(res.data.data);
        }
      });
    },
    onToolbarPreparing(e) {
      e.toolbarOptions.items.unshift({
        location: 'after',
        widget: 'dxButton',
        options: {
          icon: 'save',
          text: '저장',
          stylingMode: "outlined",
          onClick: this.save.bind(this)
        }
      });
    },
    save(e) {
      
      var params = {};
      if (!this.selectedUserId) {
        fn.notifyError('사용자 선택 후 진행 필요');
        return;
      }

      params.targetUserId = this.selectedUserId;
      var selectedData = this.grid.getSelectedRowsData();

      if (selectedData.length < 1) {
        fn.notifyError('하나 이상의 스페이스 선택 후 진행 필요');
        return;
      }

      params.spaceList = JSON.stringify(selectedData);

      e.component.option('disabled', true);
      dsu.getAxiosOBJPost('/api/AATH/insert', params).then(res => {
        let rtnMsg = res.data.msg;
        if (res.data.result == 'SUCCESS') {
          fn.notifySuccess(rtnMsg);
        } else {
          fn.notifyError(rtnMsg);
        }
        e.component.option('disabled', false);
      });
    }
  }
};

</script>

<style scoped>
#gridContainer {
  height: calc(100vh - 330px);
}
</style>